import { t } from '@lingui/core/macro';
import { SearchAggregationType } from 'shared/domains/apollo/generated/types';
import { dmsToSearchField, getAggregationTypesForProperty, getMetadataProperties, getFieldLabel, isFieldAllowedForAggregation, } from '../../../utils/metadataProperties';
const STATIC_FIELDS = {
    [SearchAggregationType.Terms]: [
        'categoryId',
        'createdByUserId',
        'entityType',
        'marketCode',
        'metadataDocumentEsigningStatus',
        'metadataDocumentIsSharedExternally',
        'metadataDocumentStatus',
        'metadataDocumentType',
    ],
    [SearchAggregationType.DateHistogram]: ['createdAt', 'metadataDocumentDateSigned', 'updatedAt'],
    [SearchAggregationType.DateRange]: ['createdAt', 'metadataDocumentDateSigned', 'updatedAt'],
    [SearchAggregationType.Metric]: [],
    [SearchAggregationType.TopHits]: [],
};
function getAggregationLabels() {
    return {
        [SearchAggregationType.Terms]: t({ message: 'Terms', comment: 'Insights - Terms aggregation' }),
        [SearchAggregationType.DateHistogram]: t({
            message: 'Date histogram',
            comment: 'Insights - Date histogram aggregation',
        }),
        [SearchAggregationType.DateRange]: t({ message: 'Date range', comment: 'Insights - Date range aggregation' }),
        [SearchAggregationType.Metric]: t({ message: 'Metric', comment: 'Insights - Metric aggregation' }),
        [SearchAggregationType.TopHits]: t({ message: 'Top Hits', comment: 'Insights - Top hits aggregation' }),
    };
}
const AGGREGATION_ORDER = [
    SearchAggregationType.Terms,
    SearchAggregationType.DateHistogram,
    SearchAggregationType.DateRange,
    SearchAggregationType.Metric,
    SearchAggregationType.TopHits,
];
function getFieldsForAggregation(aggregationType) {
    const fromProperties = getMetadataProperties()
        .filter((property) => !property.isHidden)
        .filter((property) => getAggregationTypesForProperty(property).includes(aggregationType))
        .map((property) => dmsToSearchField(property.name));
    const fromStatics = (STATIC_FIELDS[aggregationType] || []).filter((field) => isFieldAllowedForAggregation(aggregationType, field));
    return [...new Set([...fromStatics, ...fromProperties])];
}
export function getAllowedProperties() {
    const labels = getAggregationLabels();
    const groups = AGGREGATION_ORDER.map((type) => ({ id: type, name: labels[type] || `${type}` }));
    const items = AGGREGATION_ORDER.flatMap((type) => getFieldsForAggregation(type)
        .map((field) => ({ id: `${type}.${field}`, field, label: getFieldLabel(field), type }))
        .sort((a, b) => a.label.localeCompare(b.label)));
    return { items, groups };
}
